<div class="content">
  @if (loading()) {
    <cue-loading />
  }
  @if (!loading()) {
    <div class="detail-wrapper">
      <div class="room-info">
        <div class="breadcrumb-container breadcrumb-mobile">
          @for (item of resourceDetail()?.location; track item; let i = $index) {
            <span class="breadcrumb">
              @if (i !== 0) {
                <cue-icon [icon]="cueArrowRight" />
              }
              <span class="part">{{ item | localizedString }}</span>
            </span>
          }
        </div>
        @if (resourceDetail()) {
          <table class="items-table">
            @if (resourceDetail().resourceTypeName | localizedString) {
              <tr>
                <th>
                  <div>
                    {{ translation.resourceDetail.type | transloco }}
                  </div>
                </th>
                <td>{{ resourceDetail().resourceTypeName | localizedString }}</td>
              </tr>
            }

            @if (resourceDetail().isCapacityUnlimited || resourceDetail().capacity != null) {
              <tr>
                <th>
                  <div>
                    {{ translation.resourceDetail.capacity | transloco }}
                  </div>
                </th>
                <td>
                  {{
                    resourceDetail().isCapacityUnlimited
                      ? (translation.common.unlimited | transloco)
                      : resourceDetail().capacity
                  }}
                </td>
              </tr>
            }
          </table>
          <div class="content-centerer-inner">
            <div class="button-container">
              <button cue-button [link]="false" size="small" (click)="openDetail()">
                {{ translation.navigation.openDetail | transloco }}
                <cue-icon [icon]="cueArrowRight" />
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
